import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {
  lazy,
  Suspense,
  useCallback,
  useEffect,
  useMemo
} from "react";
import {
  setCurrentRouteKey,
  setInIframe,
  setLayoutType,
  setPreviousLayoutType
} from "../../Store/auth/authSlice";
import useAuth from "../../Utils/hooks/useAuth";

const AppRoute = ({component, routeKey, ...props}) => {

  const {authority = 'public'} = props

  const {secure, currentRouteKey, loading} = useSelector((state) => state.auth)

  const {authed} = useAuth()

  const location = useLocation()

  const dispatch = useDispatch()

  const layoutType = useSelector((state) => state.auth.layoutType)
  const previousLayout = useSelector((state) => state.auth.previousLayoutType)

  const handleLayoutChange = useCallback(() => {
    dispatch(setCurrentRouteKey(routeKey))

    if (props.layout && props.layout !== layoutType) {
      dispatch(setPreviousLayoutType(layoutType))
      dispatch(setLayoutType(props.layout))
    }

    if (!props.layout && previousLayout && layoutType !== previousLayout) {
      dispatch(setLayoutType(previousLayout))
      dispatch(setPreviousLayoutType(''))
    }
  }, [dispatch, layoutType, previousLayout, props.layout, routeKey])

  const checkForIframe = useCallback(() => {
    dispatch(setInIframe(window.location !== window.parent.location));
  }, [dispatch])

  useEffect(() => {
    handleLayoutChange()
    checkForIframe()
  }, [
    location,
    handleLayoutChange,
    checkForIframe
  ])

  useEffect(() => {
    if (authority === 'secure') authed();
  }, [authority, currentRouteKey])

  const Element = useMemo(() => {
    if (secure) {
      return component
    }

    return loading ?  lazy(() => import('../shared/loaders/Plain')) :  
      lazy(() => import('../../Views/auth/NotAvailable'))
  }, [secure, loading, component])


  return (
    <Suspense>
      <Element {...props}/>
    </Suspense>
  )
}

export default AppRoute
